/**
 * TODO: Add core pages as fallback for the 3 standard Magento page types, right now everything is pulled from app/config
 */
import { default as AppPageTypes } from "app/config/routing/pageTypes";

export default {
  ...AppPageTypes
};
